import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { PromptModal } from '../../components/Modal';
import Button from '../../components/Button';
import Content from '../../components/Content';
import Flash from '../../components/Flash';
import Header from '../../components/Header';
import Loader from '../../components/Loader';
import dhid from '../../../../dhid';
import logo from './dh-jkpg.png';
import styles from './achievements.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  onRequestOpenFn: PropTypes.func,
  error: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    stackPush: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      chain: PropTypes.string,
    }),
  }).isRequired,
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    shortcode: PropTypes.string.isRequired,
    pub_exhibitors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })),
  }),
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  claimError: PropTypes.shape({
    message: PropTypes.string,
    error_description: PropTypes.string,
  }),
};


function Motes({ history, onRequestOpenFn }) {
  const [infoModal, setInfoModal] = React.useState(false);
  const [valid, setValid] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const iframeRef = React.useRef();
  React.useEffect(() => {
    if (iframeRef.current) {
      // api key sh-api-0870153d-cc33-4f97-bf63-102256b33e6d

      // special hack for safari that trows an error the first time you access contentDocument
      let ref = null;
      try {
        ref = (iframeRef.current.contentWindow || iframeRef.current.contentDocument);
      } catch (e) {
        console.log('failed to access frame, trying again', e);
        ref = (iframeRef.current.contentWindow || iframeRef.current.contentDocument);
      }

      console.log('motes started', ref);
      ref.addEventListener('load', (msg) => {
        console.log('iframe loaded ', msg);
        ref.postMessage(JSON.stringify({
          type: 'Initial',
          content: {
            msg: 'hi2',
            appId: 'sh-app-717defd8-ed61-4848-ae37-7bee0bb600c2',
            enableMsgDebug: true,
          },
        }), '*');
      });

      const handler = (msg) => {
        if (msg?.origin !== 'https://dev.motes.dk') {
          return;
        }

        const pkg = JSON.parse(msg?.data);
        switch (pkg?.type) {
          case 'Initial':
            ref.postMessage(JSON.stringify({
              type: 'Initial',
              content: {
                msg: 'hi',
                appId: 'sh-app-717defd8-ed61-4848-ae37-7bee0bb600c2',
                enableMsgDebug: true,
              },
            }), '*');
            ref.postMessage(JSON.stringify({
              type: 'Login',
              content: {
                provider: 'DreamHack',
                idToken: dhid.getToken().substring(7),
              },
            }), '*');
            break;
          default:
            console.error('iframe msg ', msg);
            break;
        }
      };

      ref.addEventListener('message', handler, false);
      ref.addEventListener('message', handler, false);
    }
  }, [iframeRef, valid]);

  React.useEffect(() => {
    if (loading && !valid) {
      try {
        navigator.geolocation.getCurrentPosition(
          () => {
            setValid(true);
            setLoading(false);
            setError(false);
          }, (err) => {
            setValid(false);
            setLoading(false);
            setError(err);
          },
          {
            timeout: 10000,
            enableHighAccuracy: true,
          },
        );
      } catch (err) {
        setLoading(false);
        setError(err);
      }
    }
  }, [loading, valid]);

  return (
    <>
      <Header
        onMenuOpen={onRequestOpenFn}
        history={history}
        showUser
        right={(
          <div
            className={styles.infoButton}
            role="button"
            tabIndex={0}
            onClick={() => setInfoModal(true)}
          >
            <i className="far fa-question" />
          </div>
        )}
      >
        Explore Jönköping
      </Header>
      <Content>
        {valid && (
          <iframe
            className={styles.iframe}
            style={{ flex: 1, border: 'none' }}
            src="https://app.storyhunt.dk/jonkoping"
            title="Jönköping storyhunt"
            allow="geolocation"
            ref={iframeRef}
          />
        )}
        {!valid && (
          <div className={styles.container}>
            <img src={logo} style={{ width: '90%', maxWidth: '400px' }} alt="Jönköping - city of DreamHack" />
            <p style={{ color: 'white' }}>
              <p>
                This is a cooperation between DreamHack and the Jönköping city.
                Its a scavanger hunt that you can participate in with help of the
                GPS in your mobile.
              </p>
              <p>
                If you experience issues, you could try launching the game in your mobile
                web browser by clicking on the question mark in the top bar
              </p>
            </p>
            <Loader loading={loading} />
            <Flash message={error && `Could not get your device geolocation: ${error?.message}`} error />
            {!loading && (
              <Button
                onClick={() => {
                  setLoading(true);
                  setError(false);
                }}
              >
                Lets go!
              </Button>
            )}
          </div>
        )}
      </Content>
      <PromptModal
        title="What is this?"
        message={(
          <>
            <p>
              This is a cooperation between DreamHack and the Jönköping city.
              Its a scavanger hunt that you can participate in with help of the GPS in your mobile.
            </p>
            <p>
              If you experience issues, you could try launching the game in your mobile
              web browser by clicking the button below
            </p>
          </>
        )}
        onRequestClose={() => setInfoModal(false)}
        isOpen={infoModal}
        action={{
          onClick: () => {
            window.open('https://app.storyhunt.dk/jonkoping');
            setInfoModal(false);
          },
          text: 'Launch in browser',
        }}
        buttonText="OK :)"
      />
    </>
  );
}

Motes.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    debugMode: state.getIn(['app', 'debug']),

    event: state.getIn(['event', 'data']),
  };
}

export default withUser(connect(mapStateToProps)(Motes));
